import { gql } from '@apollo/client'

export const CREATE_USER_TOUR_RECORD = gql`
  mutation CreateUserTourRecord($data: UserTourRecordInput!) {
    createUserTourRecord(data: $data) {
      tour {
        id
        name
      }
    }
  }
`
